export const RedirectNewPage = url => {
	window.open(url, "_blank");
};
